module.exports = __webpack_public_path__ + "img/banner.a528be27.jpg";